// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import { Card, Tabs, message } from 'antd';
import {
	UserOutlined,
	SettingOutlined,
	AuditOutlined,
	BgColorsOutlined,
	BulbOutlined,
	CheckCircleOutlined,
	BellOutlined,
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import Users from '../Users/Users';
import { style } from '../../Styles';
import { getSettings, resetSettingsData } from '../../redux/settingsSlice';
import AuditLogs from './AuditLogs';
import { getTenantBrand } from '../../redux/tenantBrandSlice';
import SettingsForm from './SettingsForm';
import TenantBrandForm from './TenantBrandForm';
import { getCancellationPolicy } from '../../redux/CancellationPolicySlice';
import CancellationPolicyForm from './CancellationPolicyForm';
import TenantFeature from './TenantFeature';
import { fetchGlobalFeatures } from '../../redux/tenantFeatureSlice';
import CarPoolingSettingForm from './CarPoolingSettingForm';
import { getCarPoolingSetting } from '../../redux/carPoolingSettingSlice';
import { TenantFeaturesContext } from '../../Context/TenantFeatureContext';
import DriverApprovalSettings from './DriverApprovalSettings';
import RiderApprovalSettings from './RiderApprovalSetting';
import NotificationSettings from './NotificationSettings';
import { CheckRiderEnabled, CheckDriverEnabled, CheckCarPoolingEnabled } from '../../Utils/CheckFeatures';
import DetailedAuditLogs from './DetailedAuditLogs';

// import TenantFeature from './TenantFeature';

const SettingsScreen = ({ role }) => {
	const {fetchCurrentTenantFeatures } = useContext(TenantFeaturesContext);
	const [activeTab, setActiveTab] = useState('1');
	const [initalValues, setInitialValues] = useState({});
	const [makingApiCall, setMakingApiCall] = useState(false);
	const { Settings } = useSelector((state) => state.settings);
	const { CancellationPolicy } = useSelector((state) => state.cancellationPolicy);

	const { globalFeatures } = useSelector((state) => state.tenantFeatures);
	const dispatch = useDispatch();
	const fetchCancellationPolicy = () => {
		setMakingApiCall(true);
		dispatch(getCancellationPolicy())
			.unwrap()
			.then(() => {})
			.catch(() => {})
			.finally(() => {
				setMakingApiCall(false);
			});
	};
	useEffect(() => {
		fetchCancellationPolicy();
	}, []);
	const fetchSettings = () => {
		setMakingApiCall(true);
		dispatch(getSettings())
			.unwrap()
			.then((res) => {
				setInitialValues(res);
			})
			.catch((e) => {
				if (e.name === 'SETTINGS_NOT_FOUND_FOR_TENANT') {
					dispatch(resetSettingsData());
					message.warning(
						'Settings not found for this tenant. Please fill the form and save.',
					);
				} else {
					message.error('Something went wrong. Please try again later.');
				}
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	const fetchSCarPoolingSettings = () => {
		setMakingApiCall(true);
		dispatch(getCarPoolingSetting())
			.unwrap()
			.then()
			.catch((e) => {
				if (e.name === 'CAR_POOLING_SETTING_NOT_FOUND_FOR_THIS_TENANT') {
					dispatch(resetSettingsData());
					message.warning(
						'Car pooling Settings not found for this tenant. Please fill the form and save.',
					);
				} else {
					message.error('Something went wrong. Please try again later.');
				}
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	const getGlobalFeatures = async () => {
		setMakingApiCall(true);
		dispatch(fetchGlobalFeatures())
			.unwrap()
			.then(fetchCurrentTenantFeatures())
			.catch()
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	useEffect(() => {
		fetchSettings();
		getGlobalFeatures();
		fetchSCarPoolingSettings();
	}, [dispatch, activeTab]);
	const onChange = (key) => {
		setActiveTab(key);
	};
	const fetchTenantBrand = () => {
		dispatch(getTenantBrand());
	};

	useEffect(() => {
		fetchTenantBrand();
	}, []);

	const renderLabel = (icon, text) => (
		<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
			{icon}
			<span style={style.navItem}>{text}</span>
		</div>
	);

	let tabItems = [
		{
			label: renderLabel(<UserOutlined />, 'Users'),
			key: '1',
			children: <Users />,
			show: true,
		},
	];
	if (role?.includes('SUPER_ADMIN')) {
		tabItems = [
			...tabItems,
			{
				label: renderLabel(<SettingOutlined />, 'Settings'),
				key: '2',
				children: (
					<SettingsForm
						initalValues={initalValues}
						makingApiCall={makingApiCall}
						Settings={Settings}
						dispatch={dispatch}
						setInitialValues={setInitialValues}
						setMakingApiCall={setMakingApiCall}
						role={role}
					/>
				),
				show: true,
			},
			{
				label: renderLabel(<SettingOutlined />, 'Cancellation policy'),
				key: '3',
				children: (
					<CancellationPolicyForm
						initialValues={CancellationPolicy?.cancellationPolicyData}
						makingApiCall={makingApiCall}
						setMakingApiCall={setMakingApiCall}
					/>
				),
				show: true,
			},
			{
				label: renderLabel(<BgColorsOutlined />, 'Tenant Brand'),
				key: '4',
				children: <TenantBrandForm />,
				show: true,
			},
			{
				label: renderLabel(<AuditOutlined />, 'Activity Log'),
				key: '5',
				children: (
					<AuditLogs
						makingApiCall={makingApiCall}
						dispatch={dispatch}
						setMakingApiCall={setMakingApiCall}
						role={role}
					/>
				),
				show: true,
			},
			{
				label: renderLabel(<AuditOutlined />, 'System Audit Log'),
				key: '6',
				children: (
					<DetailedAuditLogs
						makingApiCall={makingApiCall}
						setMakingApiCall={setMakingApiCall}
						role={role}
					/>
				),
				show: true,
			},
			{
				label: renderLabel(<BulbOutlined />, 'Tenant Features'),
				key: '7',
				children: <TenantFeature role={role} globalFeatures={globalFeatures} />,
				show: true,
			},
			{
				label: renderLabel(<BulbOutlined />, 'Car Pooling Settings'),
				key: '8',
				children: (
					<CarPoolingSettingForm
						makingApiCall={makingApiCall}
						dispatch={dispatch}
						setMakingApiCall={setMakingApiCall}
						role={role}
					/>
				),
				show: CheckCarPoolingEnabled(),
			},
			{
				label: renderLabel(<CheckCircleOutlined />, 'Driver Approval'),
				key: '9',
				children: <DriverApprovalSettings />,
				show: CheckDriverEnabled(),
			},
			{
				label: renderLabel(<CheckCircleOutlined />, 'Rider Approval'),
				key: '10',
				children: <RiderApprovalSettings />,
				show: CheckRiderEnabled(),
			},
			{
				label: renderLabel(<BellOutlined />, 'Notification Settings'),
				key: '11',
				children: <NotificationSettings />,
				show: true,
			},
		];
	}
	return (
		<Card
			style={{
				margin: 16,
				maxHeight: '90%', // Set maximum width
				height: 'auto', // Allow width to be dynamic
			}}>
			<Tabs
				onChange={onChange}
				type='card'
				items={tabItems.filter((tab) => tab.show)}
				defaultActiveKey={activeTab}
			/>
		</Card>
	);
};

export default SettingsScreen;
